/* global globalThis */
import React from "react";
import { CNavLink } from "./c/CHeader";
import CUserImageIcon from "../../CUserImageIcon";
import { useTranslations, useUrlInfo } from "examsbook-react-sdk/custom-hooks";
import { Box, List, ListItem, Typography } from "@material-ui/core";
import { setSubdomain } from "examsbook-react-sdk/actions/getSettingsAction";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { logoutUser } from "examsbook-react-sdk/services/userService";
import { getUser } from "examsbook-react-sdk/actions";
import PropTypes from "prop-types";

/**
 * UserMenuList
 * @param props
 * @returns {*}
 * @constructor
 */
function UserMenuList({ user, profile }) {
  const userName = user?.user?.name || user?.name;
  const userImage = user?.user?.image || user?.image;
  const userCity = user?.user?.city || user?.city;
  const dispatch = useDispatch();
  const t = useTranslations();
  const { currentHost } = useUrlInfo();

  const logout = async () => {
    logoutUser()
      .then((response) => {
        if (response?.status === 200) {
          localStorage.clear();
          Object.keys(Cookies.get()).forEach((cookieName) => {
            Cookies.remove(cookieName, {
              path: "/",
              domain: currentHost,
              secure: true,
            });
          });

          dispatch(setSubdomain(null));
          globalThis.ReactNativeWebView?.postMessage(
            JSON.stringify({
              type: "LOGOUT",
            })
          );

          const returnToUrl = response?.data?.returnToUrl;

          if (
            process.env.NODE_ENV === "production" ||
            process.env.NODE_ENV === "staging"
          ) {
            globalThis.location.href = returnToUrl;
          } else {
            globalThis.location.href = "/login";
          }
        } else {
          console.log("Something went wrong during logout.");
        }
      })
      .catch((error) => {
        console.log(error.message)
      });
  };

  const handleProfileClick = () => {
    dispatch(getUser());
  };

  return (
    <React.Fragment>
      {profile ? (
        <Box id="userSectionId">
          <CUserImageIcon src={userImage} />
          <List className="sub-menus">
            <ListItem onClick={handleProfileClick}>
              <CNavLink to="/my-profile">{t("my_profile")}</CNavLink>
            </ListItem>
            <ListItem onClick={() => logout()}>{t("logout")}</ListItem>
          </List>
        </Box>
      ) : (
        <Box id="contentBlockId">
          <Typography variant="inherit" className="profile-info" id="contentId">
            {userName}
          </Typography>
          <Typography
            variant="inherit"
            className="profile-info"
            id="content2Id"
          >
            {userCity}
          </Typography>
        </Box>
      )}
    </React.Fragment>
  );
}

export default UserMenuList;

const userShape = PropTypes.shape({
  name: PropTypes.string,
  image: PropTypes.string,
  city: PropTypes.string,
});

UserMenuList.propTypes = {
  profile: PropTypes.bool,
  user: PropTypes.shape({
    name: PropTypes.string,
    image: PropTypes.string,
    city: PropTypes.string,
    user: userShape,
  }),
};
